// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.listings.RentalManagerUserPropertyListingsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyListingsApplicationsResponseWebDto,
  UserPropertyListingsLeasesResponseWebDto,
  UserPropertyListingsPaymentsResponseWebDto,
  UserPropertyListingsStatusesResponseWebDto,
} from '../..';

interface ApplicationsParams {
  includeActive?: boolean;
  includeInactive?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface LeasesParams {
  includeActive?: boolean;
  includeInactive?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface PaymentsParams {
  includeActive?: boolean;
  includeInactive?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface StatusesParams {
  includeActive?: boolean;
  includeInactive?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerUserPropertyListingsWebApiHandler_applications_Path =
  '/api/web/v1/users/properties/listings/applications';

/**
 * Get listings including whether applications allowed
 */
export const RentalManagerUserPropertyListingsWebApiHandler_applications = (
  getParams: ApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ApplicationsParams, never, UserPropertyListingsApplicationsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListingsWebApiHandler_applications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyListingsWebApiHandler_leases_Path =
  '/api/web/v1/users/properties/listings/leases';

/**
 * Get listings including whether leases allowed
 */
export const RentalManagerUserPropertyListingsWebApiHandler_leases = (
  getParams: LeasesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeasesParams, never, UserPropertyListingsLeasesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListingsWebApiHandler_leases_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyListingsWebApiHandler_payments_Path =
  '/api/web/v1/users/properties/listings/payments';

/**
 * Get listings including whether payments allowed
 */
export const RentalManagerUserPropertyListingsWebApiHandler_payments = (
  getParams: PaymentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PaymentsParams, never, UserPropertyListingsPaymentsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListingsWebApiHandler_payments_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyListingsWebApiHandler_statuses_Path =
  '/api/web/v1/users/properties/listings/statuses';

/**
 * Get listings sorted by active status
 */
export const RentalManagerUserPropertyListingsWebApiHandler_statuses = (
  getParams: StatusesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StatusesParams, never, UserPropertyListingsStatusesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListingsWebApiHandler_statuses_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
